const keys = require('./keys')

module.exports = Object.assign({}, { keys })
